import api from "../utils/api";

/**
 * @returns Attachment
 */

export const deleteAttachment = (id) => {
    return api.delete(`/attachments/${id}`);
};
